import React from 'react';
import { connect } from 'react-redux';
import util from 'Utils/commonUtil';
import { loadLanguage } from 'Utils/jwtUtil';
// Components
import Header from 'Components/common/Header';
import BasicButton from 'Components/common/BasicButton';
import Counter from 'Components/counter/Counter';
import ProductImage from 'Components/commonOrder/ProductImage';
import Anchor from 'Components/common/Anchor';
import CommonDialogWrapper from 'Components/replenishment/CommonShippingDetails'
import PackageDetailsDialog from 'Components/host/PackageDetailsDialog'
import { Checkbox } from '@material-ui/core';
import SearchInput from 'Components/common/SearchInput';

// Actions
import { openNotification } from 'Actions/notification'; 
import { getF1OrderDetails, productsReceive, getAllSkuConditionList, updateF1OrderReceiveSearchList, updateF1OrderReceiveOrder } from 'Actions/host';
import { T } from 'Actions/translate';
import { getSkuReplenishmentDetails } from 'Actions/host'

class F1OrderReceive extends React.Component {
    state = {
        productsReceivingQuantity: [],
        receiveBtnsIsLoading: [],
        receiveAllBtnIsLoading: false,
        exitOpened: false,
        receiveExitOpened: false,
        f1OrderReceiveData: [],
        isAllReceive: false,
        productQuantity: [],
        currentItem: null,
        currentIndex: 0,
        checked: true,
        defaultCheck: null,
        checkAll: true,
        currentProductIds: [],
        allReceiveOrderArry: [],
        f1OrderReceiveList: []
    }

    componentWillMount() {        
        this.props.updateF1OrderReceiveSearchList({
			'queryKey': { $set: '' }
        });
        this.getOrderDetails();
    }

    search = () => {
        this.setState({ f1OrderReceiveList: [] });
        this.getOrderDetails(this.props.queryKey);
    }

    getOrderDetails = (queryKey) => {
        let paramsObj = '';
        if (typeof queryKey !== 'undefined' && queryKey) {
            paramsObj = {
                id: this.props.match.params.id,
                queryKey: this.props.queryKey
            }
        } else {
            paramsObj = this.props.match.params;
        }

        this.props.getF1OrderDetails(paramsObj).then(res => {
            let productsReceivingQuantity = [];
            let receiveBtnsIsLoading = [];
            let allF1OrderReceiveList = [];

            res.data && res.data.orderProducts && res.data.orderProducts.forEach((item, index) => {
                productsReceivingQuantity[index] = item.quantity - (item.receivedQuantity || 0);
                receiveBtnsIsLoading[index] = false;
                allF1OrderReceiveList.push(item);
            });

            this.setState({ productsReceivingQuantity, receiveBtnsIsLoading, f1OrderReceiveList: allF1OrderReceiveList });
        });
    }

    inputValid = (value, index) => {
        let { productsReceivingQuantity } = this.state;

        productsReceivingQuantity[index] = value;

        this.setState({ productsReceivingQuantity });
    }

    singleReceive = (item, index) => {
        let isReceiveFlag = true;

        if (this.state.currentProductIds.length > 0) {
            if (this.state.currentProductIds[0].productId === item.productId) {
                isReceiveFlag = this.state.currentProductIds[0].isChecked;
            }
        }
        if (isReceiveFlag) {
            this.props.getAllSkuConditionList({ids: [item.productId]}).then(res => {
                if(res.status === 'success'){
                    let params = {
                        receiveExitOpened: 'receiveExitOpened',
                        resData: res.data,
                        isAllReceive: false,
                        item: item,
                        index: index
                    };
                    this.openPackageConditionDialog(params);
                }
            });
        } else {
            this.props.openNotification(T('host_receive_select_sku'), 'danger');
        }
    }

    singleHandleCheck = (index, event)  => {
        let isCheckedFlag = event.target.checked;
        let updateF1OrderList = this.state.f1OrderReceiveList;
        
        this.setState({
            f1OrderReceiveList: updateF1OrderList.map((item, idx) => idx === index ? {...item, checked:  isCheckedFlag} : item)
        });
    }

    handleCheck = name => event => {
        let updateF1OrderList = this.state.f1OrderReceiveList;
        let testArry = [];
        util.isArray(updateF1OrderList) && updateF1OrderList.map((item, idx) => {
            let currentItem = Object.assign({}, item);
            currentItem.checked = event.target.checked;
            testArry.push(currentItem);
            return null
        })

		this.setState({ 
            'checkAll': event.target.checked,
            f1OrderReceiveList: testArry
        });
    }

    allReceive = () => {
        const { productsReceivingQuantity } = this.state;
        const { F1OrderDetails } = this.props;
        let productQuantity = [];
        let productIds = [];

        let allReceiveOrderArry = this.state.f1OrderReceiveList;
        let receiveOrderArry = allReceiveOrderArry.filter(item => item.checked);

        F1OrderDetails.orderProducts && F1OrderDetails.orderProducts.forEach((item, index) => {
            productQuantity.push({ orderProductId: item.id, quantity: productsReceivingQuantity[index]});
            if(productsReceivingQuantity[index] > 0){
                productIds.push(item.productId);
            }
        });
        
        let quantityNonZeroArry = productQuantity.filter(item => item.quantity !== 0);

        let currentProductIdsArry=receiveOrderArry.filter(item => quantityNonZeroArry.some(ele=> ele.orderProductId === item.id));

        let currentProductIds=productIds.filter(item => currentProductIdsArry.some(ele=> ele.productId === item));

        if(this.state.checkAll || receiveOrderArry.length > 0){
    
            this.setState({ receiveAllBtnIsLoading: true });
    
            if (currentProductIds.length <= 0) {
                this.props.openNotification(T('host_receive_invalid_quantity'), 'danger');
            } else {
                this.props.getAllSkuConditionList({ids: currentProductIds}).then(res => {
                    
                    if(res.status === 'success'){
                        let params = {
                            receiveExitOpened: 'receiveExitOpened',
                            resData: res.data,
                            isAllReceive: true,
                            productQuantity: productQuantity
                        };
                        this.openPackageConditionDialog(params);
                    }
                });
            }
        } else {
            this.props.openNotification(T('host_receive_select_batch_sku'), 'danger');
        }
    }

    getBatchReceiveOrderArry = () => {
        let productQuantity = this.state.productQuantity;
        let allReceiveOrderArry = this.state.f1OrderReceiveList;

        let receiveOrderArry = allReceiveOrderArry.filter(item => item.checked);
        let currentAllOrderArry=productQuantity.filter(item => receiveOrderArry.some(ele=> ele.id === item.orderProductId));
        
        return currentAllOrderArry;
    }

    shipConfirmationHandle = () => {
        if (this.state.isAllReceive) {
            let allProductQuantity = this.getBatchReceiveOrderArry();
            this.props.productsReceive({
                orderId: this.props.match.params.id,
                productQuantity: allProductQuantity
            }).then(res => {
                this.props.openNotification(T('notification_all_goods_received_successfully'), 'success');
                this.props.history.replace('/F1OrderList');
                this.setState({ receiveAllBtnIsLoading: false, receiveExitOpened: false });
            }).catch(res => {
                this.setState({ receiveAllBtnIsLoading: false });
            });
        } else {
            const { productsReceivingQuantity, receiveBtnsIsLoading } = this.state;
    
            receiveBtnsIsLoading[this.state.currentIndex] = true;
    
            this.setState({ receiveBtnsIsLoading });
    
            this.props.productsReceive({
                orderId: this.props.match.params.id,
                productQuantity: [{ orderProductId: this.state.currentItem.id, quantity: productsReceivingQuantity[this.state.currentIndex] }]
            }).then(res => {
                this.props.openNotification(T('notification_successful_receipt_of_goods'), 'success');
                receiveBtnsIsLoading[this.state.currentIndex] = false;
                this.setState({ receiveBtnsIsLoading, receiveExitOpened: false, f1OrderReceiveList: [] });
                this.getOrderDetails();
            }).catch(res => {
                receiveBtnsIsLoading[this.state.currentIndex] = false;
                this.setState({ receiveBtnsIsLoading });
            })

        }
    }

    checkQuantity = () => {
        const { productsReceivingQuantity } = this.state;
        let disabled = true;

        productsReceivingQuantity && productsReceivingQuantity.forEach(item => {
            if(item > 0) disabled = false;
        });

        return disabled;
    }
    goBack = () => this.props.history.goBack();

	openDialog = (name, orderId, productId) => {
		this.setState({
			exitOpened: true
        })
        this.props.getSkuReplenishmentDetails({ orderId: orderId, productId: productId });
	}

	openPackageConditionDialog = (params) => {
		this.setState({
			receiveExitOpened: true,
            f1OrderReceiveData: typeof params.resData !== 'undefined' ? params.resData : [],
            isAllReceive: params.isAllReceive,
            currentItem: params.item,
            currentIndex: params.index,
            productQuantity: params.productQuantity

        })
	}

	closeDialog = (name) => {
		if (this.state[name]) {
			this.setState({
                [name]: false,
                f1OrderReceiveData: []
			})
		}
	}

	showShippmentDetails = (orderId, productId) => {
		this.openDialog('exitOpened', orderId, productId);
    }

    onChange = (title, value) =>{
        this.props.updateF1OrderReceiveSearchList({
            [title]: { $set: value }
        });
    } 
    
    render() {
        const { F1OrderDetails, skuReplenishmentDetail } = this.props;
        const { productsReceivingQuantity, receiveBtnsIsLoading, exitOpened, receiveExitOpened, f1OrderReceiveData, checkAll, f1OrderReceiveList } = this.state;
        const tableThContent = ['host_fone_receive_amount', 'host_fone_receive_date'];
        let lang = loadLanguage();

        if (F1OrderDetails.orderProducts) {
            for (let n=0; n < F1OrderDetails.orderProducts.length; n++){
                F1OrderDetails.orderProducts[n]['checked'] = true;
            }
        }

        return(
            <div className="F1-order-receive-container">
                <div className='container-max-width is-fixed background'></div>
	      		<div className='container-max-width is-fixed background-cover'></div>

                <Header hasArrowBackIos={ true } backEvent={this.goBack}>
                    <p className="header-order-number">{T('host_fone_order_number')} <span className="numer">{ F1OrderDetails.number }</span></p>
                    <div className="header-search-input">
                       <SearchInput title="queryKey" value={ this.props.queryKey } placeholder={ T('enter_sku') } search={ this.search } onChange={ this.onChange }></SearchInput>
                    </div>
                </Header>
                <ul className="F1-order-products-list">
                    {
                        f1OrderReceiveList && f1OrderReceiveList.map((p, index) => (
                            <li key={ index }>
                                <div className="checkbox">
                                    <Checkbox
                                        checked={ p.checked }
                                        onChange={this.singleHandleCheck.bind(this, index)}
                                    />
                                </div>
                                <div className="img-box"><ProductImage src={ p.product && p.product.productPic } alt={ p.product && p.product.productName }/></div>
                                { lang !== 'EN' ?
                                <div className="details">
                                    <div className="sku-replenishment-detail">
                                        <p className="sku text-ellipsis">{ p && p.product && p.product.sku }</p>
                                        <p className="replenishment-detail-area text-ellipsis"><Anchor className={p.receivedQuantity === 0 ? 'btn btn-disabled' : 'btn'} disabled={p.receivedQuantity === 0 ? true : false } onClickOfSingleTap={() => this.showShippmentDetails(p.orderId, p.productId)}>{T('fone_order_shippment_details')}</Anchor></p>
                                    </div>
                                    <div className="quantitys">
                                        <p className="replenishment-quantity text-ellipsis"><label>{T('host_fone_replenishment_amount_colon')}</label>{ p.quantity }</p>
                                        <p className="received-quantity text-ellipsis"><label>{T('host_fone_received_amount')}</label>{ p.receivedQuantity || 0 }</p>
                                    </div>
                                    <div className="receive-quantity">
                                        <label>{T('host_fone_receive_amount_colon')}</label>
                                        <Counter defalutValue={ productsReceivingQuantity[index] } inputValid={ value => this.inputValid(value, index) } options={{ min: 0, max: p.tobeshippedQuantity }}></Counter>
                                        <BasicButton className="receive-btn" type="primary" disabled={ !productsReceivingQuantity[index] || productsReceivingQuantity[index] === '0' } loading={ receiveBtnsIsLoading[index] } onClickOfSingleTap={ () => this.singleReceive(p, index) }>{T('host_receipt')}</BasicButton>
                                    </div>
                                    <p className='sku-specifications'><label>{T('fone_order_specifications_colon')}</label><span dangerouslySetInnerHTML={{ __html: p.product.specifications }} /></p>
                                </div> 
                                : 
                                <div className="details">
                                    <div className="sku-replenishment-detail">
                                        <p className="sku">{ p && p.product && p.product.sku }</p>
                                        <p className="en-replenishment-detail-area"><Anchor className={p.receivedQuantity === 0 ? 'btn btn-disabled' : 'btn'} disabled={p.receivedQuantity === 0 ? true : false } onClickOfSingleTap={() => this.showShippmentDetails(p.orderId, p.productId)}>{T('fone_order_shippment_details')}</Anchor></p>
                                    </div>
                                    <div className="quantitys">
                                        <label style={{color: '#B1B1B1'}}>{T('host_fone_replenishment_amount_colon')}&nbsp;</label>{ p.quantity }
                                    </div>
                                    <div className="quantitys">
                                        <label style={{color: '#B1B1B1'}}>{T('host_fone_received_amount')}&nbsp;</label>{ p.receivedQuantity || 0 }
                                    </div>
                                    <div className="receive-quantity">
                                        <label>{T('host_fone_receive_amount_colon')}</label>
                                        <Counter defalutValue={ productsReceivingQuantity[index] } inputValid={ value => this.inputValid(value, index) } options={{ min: 0, max: p.tobeshippedQuantity }}></Counter>
                                    </div>
                                    <div className='sku-specifications'>
                                        <label>{T('fone_order_specifications_colon')}</label><span dangerouslySetInnerHTML={{ __html: p.product.specifications }} />
                                    </div>
                                    <div className='sku-specifications'>
                                        <BasicButton className="en-receive-btn" type="primary" disabled={ !productsReceivingQuantity[index] || productsReceivingQuantity[index] === '0' } loading={ receiveBtnsIsLoading[index] } onClickOfSingleTap={ () => this.singleReceive(p, index) }>{T('host_receipt')}</BasicButton>
                                    </div>
                                </div> }
                            </li>
                        ))
                    }
                </ul>
                <div className="footer-wrap">
                    <div className="footer clearfix container-max-width is-fixed">
                        <div className='all-selected' xs={3}>
                            <Checkbox
                                checked={checkAll}
                                onChange={this.handleCheck('checkAll')}
                            />
                            <span className='all-selected-title'>{T('f1_order_receive_select_all')}</span>
                        </div>
                        <BasicButton className="all-receive-btn pull-right" type="primary" disabled={ this.checkQuantity() } onClickOfSingleTap={ this.allReceive }>{T('host_full_receipt')}</BasicButton>
                    </div>
                </div>
                <PackageDetailsDialog skuReplenishmentDetailData={f1OrderReceiveData} shipConfirmationHandle={ this.shipConfirmationHandle } closeDialog={ this.closeDialog } opened={ receiveExitOpened } isOperateFlag='receive' /> 
                <CommonDialogWrapper skuReplenishmentDetailData={skuReplenishmentDetail} closeDialog={ this.closeDialog } exitOpened={ exitOpened }  tableThContent={tableThContent}/>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { host } = state;
	return {
        F1OrderDetails: host.F1OrderDetails,
		skuReplenishmentDetail: host.skuReplenishmentDetail,
        queryKey: host.f1OrderReceiveSearchfields.queryKey,
        updateF1OrderList: host.updateF1OrderList
	};
};

const mapDispatchToProps = {
    getF1OrderDetails,
    productsReceive,
    openNotification,
    getSkuReplenishmentDetails,
    getAllSkuConditionList,
    updateF1OrderReceiveSearchList,
    updateF1OrderReceiveOrder
};

export default connect(mapStateToProps, mapDispatchToProps)(F1OrderReceive);
